<template>
    <div class="TQ_bg_gray4 TQ_padding_4px TQ_borderRadius">

        <div class="TQ_scrollable ">

            <table class="lc_body TQ_center TQ_width_100p TQ_borderBox">

                <!-- search  -->
                <tr class="lc_search " v-if="displaySearch">
                    <!-- index -->
                    <td class="lc_cell">
                        <!--index-->
                    </td>

                    <!-- cell data -->
                    <td class="lc_cell" v-for="col in columns">
                        <input class="TQ_input_fullScreen TQ_borderBox"
                               :placeholder="ass_strings.oneWord_search[systemLangCode]"
                               v-model="search[col.label]"/>
                    </td>

                </tr>

                <!-- titles -->
                <tr class="lc_header TQ_text_capitalize TQ_text_bold ">
                    <!-- index -->
                    <td class="lc_cell" :class="p_tdClasses_s">
                        <!--index-->
                    </td>

                    <!-- cell data -->
                    <td class="lc_cell TQ_clickable"
                        @click="m_arrangeByColumn_f(index_n)"
                        :class="p_tdClasses_s" v-for="(col, index_n) in columns">
                        <div class="TQ_grid_col_1frAuto">
                            <div class="TQ_grid_verticalCenter">
                                {{col.label}}
                            </div>
                            <tq-image class="TQ_width_12px TQ_grid_verticalCenter" :pb_src_r="ass_img_caretDown" v-if="index_n === selectedOrderByCol_o.index_n && selectedOrderByCol_o.descending_b"/>
                            <tq-image class="TQ_width_12px TQ_grid_verticalCenter" :pb_src_r="ass_img_caretUp" v-if="index_n === selectedOrderByCol_o.index_n && !selectedOrderByCol_o.descending_b"/>
                        </div>
                    </td>

                    <!-- actions -->
                    <td class="lc_cell" :class="p_tdClasses_s" v-if="p_actions_ao">
                        {{ass_strings.oneWord_actions[systemLangCode]}}
                    </td>

                </tr>

                <!-- table data -->
                <tr class="lc_row"
                     :class="{'rowClickable' : p_clickRow_f, 'TQ_bg_gold' : (p_selectedRowIndex_n % maxRowsAtt === index_n && co_currentSelectedRowPage_n === currentPageNum_n)}"
                     v-for="(row_o, index_n) in co_getRows_ao" @click="p_clickRow_f && p_clickRow_f(row_o)">

                    <!-- index -->
                    <td class="lc_cell TQ_height_20px" :class="p_tdClasses_s">
                        <div v-if="row_o !== null">
                            {{(currentPageNum_n*maxRowsInPage_n) + index_n + 1}}
                        </div>
                    </td>

                    <!-- cell data-->
                    <td class="lc_cell TQ_verticalAlignMiddle" :class="m_dom_cellDataClass_s(col, row_o)" v-for="(col, index_n) in columns">

                        <div v-if="row_o == null"></div>

                        <!-- avatar -->
                        <tq-avatar v-else-if="col.avatar_f && col.avatar_f(row_o)"
                                   :p_ud_avatar_c="col.avatar_f(row_o)"
                                   :key="$options.name + index_n"
                                   class="TQ_width_40px TQ_borderRadius"/>

                        <!-- cell data image-->
                        <tq-image v-else-if="col.img_f"
                                  class="TQ_width_40px TQ_borderRadius"
                                  :class="col.imgClass_f && col.imgClass_f(row_o)"
                                  :pb_src_r="col.img_f(row_o) ? col.img_f(row_o) : ass_img_user_b"
                                  :pb_default-img_r="col.defaultImg_f != null ? col.defaultImg_f(row_o) : null"/>

                        <!-- cell data input - editable -->
                        <input v-else-if="col.changeCellData_f"
                               class="TQ_padding_4px TQ_center"
                               :value="m_dom_getCellData_fs(row_o,col)"
                               @change="m_dom_updateCellData_f(row_o,col,$event)">

                        <!-- cell data input - html -->
                        <div v-else-if="col.html_f"
                             v-html="col.html_f(row_o, col)"></div>

                        <!-- cell data input - not editable -->
                        <div v-else> {{m_dom_getCellData_fs(row_o,col)}}</div>
                    </td>

                    <!-- cell action -->
                    <td class="lc_cell TQ_align_initial" :class="p_tdClasses_s + ' ' + p_tdClassesActions_s" v-if="p_actions_ao">

                        <tq-btn-approve
                            :is="action_o.popupText_byLangCode ? TqBtnApprove : 'div'"
                            v-for="(action_o, actionIndex_n) in m_dom_getRowActions(row_o)"
                            :key="actionIndex_n"
                            :class="action_o.class"
                            class="TQ_btn TQ_margin_4px TQ_borderRadius"
                            :system-lang-code="systemLangCode"
                            :popup-text="action_o.popupText_byLangCode"
                            :approve-cb="() => {action_o.action_f(row_o, index_n)}">
                            <div @click="() => {!action_o.popupText_byLangCode && action_o.action_f(row_o, index_n)}">
                                <tq-image v-if="action_o.img_r" :pb_src_r="action_o.img_r" class="TQ_width_16px TQ_verticalAlignMiddle"/>
                                <div v-if="action_o.img_r && action_o.label_byLangCode" class="TQ_verticalAlignMiddle TQ_inline TQ_padding_4px"></div>
                                <div class="TQ_verticalAlignMiddle TQ_inline" v-if="action_o.label_byLangCode"> {{action_o.label_byLangCode[systemLangCode]}}</div>
                            </div>
                        </tq-btn-approve>

                    </td>
                </tr>
            </table>

        </div>

        <!-- lc_bottom -->
        <div class="lc_bottom TQ_grid_col_1frAuto1fr" >

            <div class="TQ_grid_verticalCenter"></div>
            <div class="TQ_inline TQ_grid_verticalCenter">
                <div class="TQ_clickable TQ_margin_2px TQ_verticalAlignMiddle TQ_bg_gray1 TQ_borderRadius TQ_box_shadow TQ_inline TQ_padding_6px TQ_textColor_white TQ_width_44px"
                     v-if="co_multiplePages_b" @click="m_action_prev_f()"> {{ass_strings.oneWord_prev[systemLangCode]}} </div>

                <div class="lc_text TQ_inline TQ_text_14px TQ_margin_4px TQ_verticalAlignMiddle">
                    {{co_getBottomLocationText_s}}
                </div>
                <div class="TQ_clickable TQ_margin_2px TQ_verticalAlignMiddle TQ_bg_purple TQ_borderRadius TQ_box_shadow TQ_inline TQ_padding_6px TQ_width_44px"
                     v-if="co_multiplePages_b" @click="m_action_next_f()"> {{ass_strings.oneWord_next[systemLangCode]}} </div>
            </div>


            <div class="TQ_align_end TQ_grid_verticalCenter">
                <tq-dropdown
                        v-if="co_showMaxRowsSelector_b"
                        class="lc_maxRowsSelect TQ_inline TQ_margin_4px TQ_verticalAlignMiddle  TQ_box_shadow TQ_center"
                        :style-select="true">
                    <div slot="select" class="TQ_borderRadius ">
                        {{maxRowsInPage_n}}
                    </div>

                    <div slot="options"
                         v-for="rowsInPage_n in [10,20,100,200]"
                         @click="m_action_changeMaxRowsInPage_f(rowsInPage_n)">
                        {{rowsInPage_n}}
                    </div>
                </tq-dropdown>
            </div>

        </div>
    </div>

</template>

<script>


    import TqAvatar from "@/components/complex/TqAvatar";
    const defaultMaxRowsAtt_n = 10
    import TqDropdown from "../basic/TqDropdown";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqBtnApprove from "./TqBtnApprove";
    import TqImage from "../basic/TqImage";
    import {ass_img_caretDown_w, ass_img_caretUp_w, ass_img_user_b} from "../../assets/scripts/Ass_Files";
    export default {
        name: "TqTable",
        components: {TqAvatar, TqImage, TqBtnApprove, TqDropdown},
        props:{
            rows:{
                type: Array,
                require: true
            },
            columns:{
                type: Array,
                require: true
            },
            maxRowsAtt:{
                type: Number,
                default: defaultMaxRowsAtt_n
            },
            p_clickRow_f:{
                type: Function,
            },
            displaySearch:{
                type: Boolean,
                default: false
            },
            systemLangCode:{
                type: String,
                default: false
            },
            p_selectedRowIndex_n:{
                type: Number,
                default: -1
            },
            p_tdClasses_s:{
                type: String
            },
            p_tdClassesActions_s:{
                type: String
            },
            p_actions_ao:{
                type: Array,
            }
        },
        data(){
            return {
                currentPageNum_n: 0,
                search: {},
                maxRowsInPage_n: this.maxRowsAtt,

                // imports
                TqBtnApprove: TqBtnApprove,
                ass_strings: ass_strings,
                ass_img_user_b: ass_img_user_b,
                ass_img_caretUp: ass_img_caretUp_w,
                ass_img_caretDown: ass_img_caretDown_w,
                selectedOrderByCol_o : {
                    index_n: null,
                    descending_b : true
                }
            }
        },
        computed:{
            co_getRows_ao(){

                let ans

                if(this.displaySearch){
                    ans = this.co_filterRows_a
                }else{
                    ans = this.rows
                }

                if(this.selectedOrderByCol_o.index_n != null){
                    let col_o = this.columns[this.selectedOrderByCol_o.index_n]

                    ans = ans.sort((rowData1, rowData2) => {
                        let ans = this.m_dom_getCellData_fs(rowData1, col_o) < this.m_dom_getCellData_fs(rowData2, col_o) ? -1 : 1
                        if(this.selectedOrderByCol_o.descending_b){
                            ans = -1 * ans
                        }

                        return ans
                    })
                }



                return ans.slice(this.currentPageNum_n*this.maxRowsInPage_n,(this.currentPageNum_n+1) * this.maxRowsInPage_n)

            },
            co_filterRows_a(){
                return this.rows.filter( row => {
                    let ans = true

                    this.columns.forEach(col => {

                        if(this.search[col.label] !== '' && this.search[col.label] != null) {
                            let cd = this.m_dom_getCellData_fs(row, col);

                            if( cd == null
                                || !cd.toString().toLowerCase().includes(this.search[col.label].toLowerCase())) {
                                ans = false
                                return
                            }
                        }
                    });
                    return ans
                })
            },
            co_getBottomLocationText_s(){

                let startingNum = this.currentPageNum_n*this.maxRowsInPage_n
                let endingNum = (this.currentPageNum_n+1) * this.maxRowsInPage_n > this.co_filterRows_a.length ? this.co_filterRows_a.length : (this.currentPageNum_n+1) * this.maxRowsInPage_n;

                return `${ass_strings.oneWord_display[this.systemLangCode]} ${startingNum} - ${endingNum} ${ass_strings.oneWord_of[this.systemLangCode]} ${this.co_filterRows_a.length}`
            },
            co_currentSelectedRowPage_n(){
                return Math.floor(this.p_selectedRowIndex_n/this.maxRowsAtt)
            },
            co_multiplePages_b(){
                return this.rows.length > this.maxRowsInPage_n
            },
            co_showMaxRowsSelector_b(){
                return this.rows.length > 20
            }
        },
        methods:{
            // action
            m_action_prev_f(){
                if(this.currentPageNum_n > 0){
                    this.currentPageNum_n--
                }
            },
            m_action_next_f(){
                if(this.currentPageNum_n < parseInt(this.rows.length / this.maxRowsInPage_n)){
                    this.currentPageNum_n++
                }
            },
            m_action_changeMaxRowsInPage_f(maxRowsInPage_n){

                if(this.currentPageNum_n * maxRowsInPage_n > this.rows.length){
                    this.currentPageNum_n = Math.floor(this.rows.length / maxRowsInPage_n)
                }
                this.maxRowsInPage_n = maxRowsInPage_n

            },

            // dom
            m_dom_getCellData_fs(row, col){
                if(typeof col.field === 'function'){
                    return col.field(row)
                }else if(typeof col.field === 'string'){
                    return row[col.field]
                }else if(col.img_f != null){
                    return null
                }else{
                    return '-'
                }
            },
            m_dom_cellDataClass_s(col, row){

                if(col.class_s){
                    return this.p_tdClasses_s + ' ' + col.class_s(row)
                }

                return this.p_tdClasses_s
            },

            m_arrangeByColumn_f(index_n){

                if(this.selectedOrderByCol_o.index_n !== index_n){
                    this.selectedOrderByCol_o.index_n = index_n
                    this.selectedOrderByCol_o.descending_b = true
                }else if(this.selectedOrderByCol_o.descending_b){
                    this.selectedOrderByCol_o.descending_b = false
                }else{
                    this.selectedOrderByCol_o.index_n = null
                    this.selectedOrderByCol_o.descending_b = true
                }
            },

            // dom
            m_dom_getRowActions(row){
                let ans_ac = []
                this.p_actions_ao.forEach((action)=>{
                    if(!action.display || action.display(row)){
                        ans_ac.push(action)
                    }
                })
                return ans_ac
            },
            m_dom_updateCellData_f(row,col,event){

                col.changeCellData_f(row,event.srcElement.value)
            },

            m_dom_refreshPageLocation_f(){
                if(this.p_selectedRowIndex_n > -1){
                    this.currentPageNum_n = this.co_currentSelectedRowPage_n

                }
            }

        },
        watch: {
            p_selectedRowIndex_n: {
                handler: function(){
                    this.m_dom_refreshPageLocation_f()
                },
                immediate: true

            },
        },
    }
    
</script>

<style scoped lang="scss">

        .lc_body{
            border-spacing:4px 4px; //bottom spacing
            border-collapse: collapse;

            .lc_maxRowsSelect{
                width: 70px;
            }

            .lc_search{
                -moz-border-radius:10px;
                -webkit-border-radius:10px;

                .lc_cell{
                    border-right: 1px solid transparent;
                    border-left: 1px solid transparent;
                    padding-bottom: 4px;
                }
            }

            .lc_header{
                background: var(--color-purple_lite);
                color: white;

                border-spacing:2px 5px; //bottom spacing

                .lc_cell{
                    border-right:1px solid white;
                    border-left:1px solid white;
                }

            }

            .lc_row{
                -moz-border-radius:10px;
                -webkit-border-radius:10px;

                &:nth-child(even){
                    background: var(--color-gray2);
                }
                &:nth-child(odd){
                    background: var(--color-gray4);
                }

                .lc_cell{
                    display: table-cell;
                    vertical-align: middle;
                    border:1px solid white;
                }


                &.rowClickable:hover{
                    background: var(--color-gold);
                    cursor: pointer;
                }
            }

        }

        .lc_bottom{

            .lc_text{
                line-height: 36px;
            }

        }


</style>